import React, { useState } from "react";
import { motion } from "framer-motion";
import { Pencil, Check, X } from "lucide-react";
import api, { errText } from "@/lib/api";
import { toast } from "sonner";

// El valor de la hora usado para calcular los USD: visible, en primera persona y editable.
// Vive en la EMPRESA (compartido). Solo USD. Subirlo agranda el número: juega a favor.
export default function TarifaEditor({ info, onRecalc }) {
  const [editando, setEditando] = useState(false);
  const [valor, setValor] = useState(info?.valor_hora || "");
  const [guardando, setGuardando] = useState(false);
  const [confirm, setConfirm] = useState(null); // {vh, mensaje} cuando el valor es extremo

  if (!info || !info.valor_hora) return null;
  const vh = info.valor_hora;

  const abrir = () => { setValor(info.valor_hora); setConfirm(null); setEditando(true); };

  const guardar = async (confirmado = false) => {
    const n = parseInt(valor, 10);
    if (!n || n < 1) { toast.error("Poné un número de dólares por hora."); return; }
    setGuardando(true);
    try {
      const { data } = await api.post("/valor-hora", { valor_hora: n, confirmado });
      if (data?.needs_confirm) { setConfirm({ vh: data.valor_hora ?? n, mensaje: data.mensaje }); return; }
      toast.success(`Listo. Recalculado a USD ${data.valor_hora ?? n} la hora.`);
      setConfirm(null);
      setEditando(false);
      onRecalc?.(data);
    } catch (e) {
      toast.error(errText(e));
    } finally {
      setGuardando(false);
    }
  };

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.5 }}
      className="card-dark p-4 mb-8" data-testid="tarifa-editor">
      {!editando ? (
        <div className="flex items-start justify-between gap-3">
          <div className="text-crema text-sm leading-relaxed" data-testid="tarifa-texto">
            Calculado a <span className="text-dorado font-medium">USD {vh} la hora</span>, que es lo que me dijiste.
            Cambialo acá si querés y se recalcula todo.
          </div>
          <button onClick={abrir} className="btn-fantasma flex items-center gap-2 shrink-0" data-testid="tarifa-editar-btn">
            <Pencil size={13} /> CAMBIAR
          </button>
        </div>
      ) : confirm ? (
        <div data-testid="tarifa-confirmar-extremo">
          <p className="text-crema text-sm leading-relaxed mb-3">{confirm.mensaje}</p>
          <div className="flex flex-wrap gap-2">
            <button onClick={() => guardar(true)} disabled={guardando} className="btn-dorado flex items-center gap-2" data-testid="tarifa-confirm-si">
              <Check size={14} /> {guardando ? "…" : "está bien"}
            </button>
            <button onClick={() => setConfirm(null)} className="btn-fantasma" data-testid="tarifa-confirm-corrijo">lo corrijo</button>
          </div>
        </div>
      ) : (
        <div>
          <div className="mono-label text-gris mb-3" data-testid="tarifa-edicion-titulo">¿CUÁNTO VALE UNA HORA TUYA? (USD)</div>
          <div className="flex items-center gap-2">
            <div className="flex items-center card-dark px-3 py-2 gap-2 flex-1" style={{ background: "rgba(255,255,255,0.03)" }}>
              <span className="mono-label text-gris">USD</span>
              <input type="number" min="1" value={valor} autoFocus
                onChange={(e) => setValor(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && guardar()}
                className="bg-transparent text-crema outline-none w-full text-lg" data-testid="tarifa-input" />
              <span className="mono-label text-gris">/ HORA</span>
            </div>
            <button onClick={() => guardar()} disabled={guardando} className="btn-dorado flex items-center gap-2" data-testid="tarifa-guardar-btn">
              <Check size={14} /> {guardando ? "…" : "RECALCULAR"}
            </button>
            <button onClick={() => setEditando(false)} className="btn-fantasma p-2" data-testid="tarifa-cancelar-btn">
              <X size={14} />
            </button>
          </div>
        </div>
      )}
    </motion.div>
  );
}
